import { ChallengeRewardProductDetail } from '../../../../types/challenges';
import CustomSelect from '../../../common/CustomSelect/CustomSelect';
import TickIcon from '../../../../assets/icons/TickIcon';
import useIsMobile from '../../../../hooks/useIsMobile';
import styles from './claimRewardModal.module.css';

type SelectVariantsStepProps = {
  products: ChallengeRewardProductDetail[];
  selectedVariants: Record<number, number>;
  onSelectVariant: (productId: number, variantId: number) => void;
};

export default function SelectVariantsStep({ products, selectedVariants, onSelectVariant }: SelectVariantsStepProps) {
  const isMobile = useIsMobile();
  const showStepper = !isMobile && products.length > 1;

  return (
    <div className={styles.variantsList}>
      {products.map((product, index) => {
        const selectedVariant = product.variants.find(
          ({ variantId }) => variantId === selectedVariants[product.productId]
        );
        const image = selectedVariant?.image || product.image;

        return (
          <div key={product.productId} className={styles.variantRow}>
            {showStepper && (
              <div className={styles.stepper}>
                <span className={styles.stepNumber}>{index + 1}</span>
                <span className={styles.stepLine} />
              </div>
            )}
            <div className={`${styles.variantContent} ${showStepper ? styles.variantContentWithStepper : ''}`}>
              <div className={styles.productCard}>
                <div className={styles.productImage}>{image && <img src={image} alt={product.name} />}</div>
                <div className={styles.productInfo}>
                  <p className={styles.productName}>{product.name}</p>
                  <p className={styles.productPrice}>Free</p>
                </div>
              </div>
              <div className={styles.variantSelect}>
                <p className={styles.fieldLabel}>Select variant *</p>
                <CustomSelect
                  labelClassName={styles.variantSelectLabel}
                  style={{ width: '100%' }}
                  selectLabel={
                    <span
                      className={`${styles.variantSelectValue} ${
                        selectedVariant ? styles.variantSelectValueActive : ''
                      }`}
                    >
                      {selectedVariant?.name || 'Select variant'}
                    </span>
                  }
                  dropDownElement={(setOpened, width) => (
                    <div className={styles.variantDropdown} style={{ width }}>
                      {product.variants.map((variant) => {
                        const isSelected = variant.variantId === selectedVariant?.variantId;
                        return (
                          <button
                            type="button"
                            key={variant.variantId}
                            disabled={!variant.available}
                            className={`${styles.variantDropdownItem} ${isSelected ? styles.active : ''}`}
                            onClick={() => {
                              onSelectVariant(product.productId, variant.variantId);
                              setOpened(false);
                            }}
                          >
                            <span>
                              {variant.name}
                              {!variant.available && ' (Out of stock)'}
                            </span>
                            {isSelected && <TickIcon color="var(--icon-highlight)" width={20} height={20} />}
                          </button>
                        );
                      })}
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
